// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XsnE2YylfDJUEWmLR6my {
  color: #FFF;
  font-family: 'Montserrat';
  transition: 0.2s;
  background-color: #034EA2;
  min-height: 200px;
}

.XsnE2YylfDJUEWmLR6my:hover{
  background-color: #013CA3;
  box-shadow: 0 0 2rem rgba(0,0,0,0.2);
  transition: all 0.2s ease-in-out;
  cursor: pointer;
};

.EHdRAFniUeqFJmUnabPQ{
  display: grid;
  padding: 1.4rem;
}

.l9VbcEdtGvBlP9TXrG23{
  font-weight: 800;
  color: #FFF;
}

.Ap0I9dykoFe74WNsdKYS{
  font-weight: 400;
  font-size: 1.2rem;
}

.QSUe7vwc6d8s1_mdPQ0Q {
  width: 30px;
  height: 30px;
}

.kUJ_hdxghFezXgnMFoGh{
  flex: 1 1 100%;
  min-height: 200px;
}

@media (min-width: 768px) {
  .kUJ_hdxghFezXgnMFoGh{
    flex: 1 1 40%;
  }
}

@media (min-width: 1024px) {
  .kUJ_hdxghFezXgnMFoGh{
    flex: 1 1 30%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CardOrgao/index.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;AACjB,CAAA;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".card {\n  color: #FFF;\n  font-family: 'Montserrat';\n  transition: 0.2s;\n  background-color: #034EA2;\n  min-height: 200px;\n}\n\n.card:hover{\n  background-color: #013CA3;\n  box-shadow: 0 0 2rem rgba(0,0,0,0.2);\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n};\n\n.grid{\n  display: grid;\n  padding: 1.4rem;\n}\n\n.h3{\n  font-weight: 800;\n  color: #FFF;\n}\n\n.p{\n  font-weight: 400;\n  font-size: 1.2rem;\n}\n\n.icon {\n  width: 30px;\n  height: 30px;\n}\n\n.container{\n  flex: 1 1 100%;\n  min-height: 200px;\n}\n\n@media (min-width: 768px) {\n  .container{\n    flex: 1 1 40%;\n  }\n}\n\n@media (min-width: 1024px) {\n  .container{\n    flex: 1 1 30%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `XsnE2YylfDJUEWmLR6my`,
	"grid": `EHdRAFniUeqFJmUnabPQ`,
	"h3": `l9VbcEdtGvBlP9TXrG23`,
	"p": `Ap0I9dykoFe74WNsdKYS`,
	"icon": `QSUe7vwc6d8s1_mdPQ0Q`,
	"container": `kUJ_hdxghFezXgnMFoGh`
};
export default ___CSS_LOADER_EXPORT___;
